import React from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageSwitcher from './common/LanguageSwitcher';

const LegalPageNavbar = () => {
  const navigate = useNavigate();

  return (
    <nav className="landing-navbar">
      <div className="navbar-container">
        <div className="logo" onClick={() => navigate('/')}>
          <span className="material-icons">school</span>
          <span>Syllera</span>
        </div>
        <div className="nav-menu">
          <a href="/#features" onClick={(e) => { e.preventDefault(); navigate('/#features'); }}>Features</a>
          <a href="/#how-it-works" onClick={(e) => { e.preventDefault(); navigate('/#how-it-works'); }}>How It Works</a>
          <a href="/#pricing" onClick={(e) => { e.preventDefault(); navigate('/#pricing'); }}>Pricing</a>
          <a href="/#testimonials" onClick={(e) => { e.preventDefault(); navigate('/#testimonials'); }}>Reviews</a>
          <a href="/resources" onClick={(e) => { e.preventDefault(); navigate('/resources'); }}>Resources</a>
          <a href="/business" onClick={(e) => { e.preventDefault(); navigate('/business'); }}>Business</a>
          <a href="/partners" onClick={(e) => { e.preventDefault(); navigate('/partners'); }}>Partners</a>
        </div>
        <div className="nav-actions">
          <LanguageSwitcher className="landing-language-switcher" />
          <button type="button" className="btn-login" onClick={() => navigate('/#login')}>Login</button>
          <button type="button" className="btn-primary" onClick={() => navigate('/signup')}>Start Learning Free</button>
        </div>
      </div>
    </nav>
  );
};

export default LegalPageNavbar;
